"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaystubsModule = /** @class */ (function () {
    function PaystubsModule() {
    }
    return PaystubsModule;
}());
exports.PaystubsModule = PaystubsModule;
